// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"36e6183c","404":"f8939717","498":"38d392b2"}[chunkId] + ".chunk.js";
};